<div class="card">
    <div class="heading">

        <span class="pi pi-users"></span>&nbsp;
        <h3 id="h3"> Select Patient </h3>
    </div>

    <p-table [columns]="cols" [value]="multirecord" [paginator]="true" [rows]="5" [rowsPerPageOptions]="[5,10,15,20]"
        totalRecords="totalRecords" pageLinks="3" [loading]="loading" [autoLayout]="true">

        <ng-template pTemplate="header" let-columns>
            <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                    <b>{{col.header}}</b>
                    <p-sortIcon [field]="col.field"></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr>
                <td *ngFor="let col of columns">
                    <ng-container *ngIf="col.field === 'user_patient.users.e_email'">
                        {{rowData['user_patient'].users.e_email}}
                    </ng-container>
                    <ng-container *ngIf="col.field === 'check'">
                        <button type="button" pButton pRipple icon="pi pi-search"
                            (click)="selectPatient(rowData)"></button>
                    </ng-container>
                    {{rowData[col.field]}}
                </td>
            </tr>

        </ng-template>
        <ng-template pTemplate="paginatorleft">
            <p-button icon="pi pi-chevron-circle-left" (click)="prev()"></p-button>
        </ng-template>
    </p-table>
</div>
